import React, { useEffect, useState } from "react"
import {
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  Image,
  message,
  InputNumber,
} from "antd"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import qrCodeImage from "../qrCode.jpg"
import TransactionManagement from "src/services/TransactionService"

const { Option } = Select

const CreateTransactionModal = ({
  open,
  onCancel,
  onSubmit,
  mode = "create",
  record,
  refresh,
}) => {
  const [form] = Form.useForm()
  const [qrCode, setQrCode] = useState(null)
  const [transactionType, setTransactionType] = useState(null)
  const [amount, setAmount] = useState("")
  const [loading, setLoading] = useState(false)

  const isView = mode === "view"

  useEffect(() => {
    if (mode !== "create" && record) {
      form.setFieldsValue(record)
      setTransactionType(record.type)
    } else {
      form.resetFields()
      setQrCode(null)
      setTransactionType(null)
    }
  }, [record, mode, open])

  const handleTypeChange = value => {
    setTransactionType(value)
    if (value === "deposit") {
      setQrCode(qrCodeImage)
    } else {
      setQrCode(null)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const values = await form.validateFields()
      let response = null

      if (values.type === "deposit") {
        response = await TransactionManagement.createDeposite(values)
      } else if (values.type === "withdrawal") {
        response = await TransactionManagement.createWithdrawal(values)
      }

      if (response?.message?.includes("thành công")) {
        // message.success(response.message)
        onSubmit?.(values)
        form.resetFields()
        refresh(prev => !prev)
      } else {
        message.error(response?.message || "Tạo giao dịch thất bại")
      }
    } catch (err) {
      console.error("Lỗi xử lý:", err)
      const errorMessage =
        err?.response?.data?.message || "Vui lòng kiểm tra lại dữ liệu"
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      title={
        mode === "create"
          ? "Tạo giao dịch"
          : mode === "edit"
          ? "Chỉnh sửa giao dịch"
          : "Chi tiết giao dịch"
      }
      onCancel={onCancel}
      onOk={handleSubmit}
      okButtonProps={{ disabled: isView }}
      confirmLoading={loading}
      cancelText="Hủy"
      okText={mode === "edit" ? "Lưu" : "Tạo"}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          {isView && (
            <Col span={8}>
              <Form.Item name="code" label="Mã giao dịch">
                <Input disabled />
              </Form.Item>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name="customer_id"
              label="Người giao dịch"
              rules={[
                { required: true, message: "Vui lòng nhập người giao dịch" },
              ]}
            >
              {/* <Input disabled={isView} /> */}
              <SelectCustomer />
            </Form.Item>
          </Col>

          {isView && (
            <Col span={8}>
              <Form.Item name="create_at" label="Ngày giao dịch">
                <Input disabled />
              </Form.Item>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name="amount"
              label="Số tiền"
              rules={[
                { required: true, message: "Vui lòng nhập số tiền" },
                {
                  validator: (_, value) => {
                    if (!value || Number(value) >= 100000) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      "Số tiền phải lớn hơn hoặc bằng 100,000",
                    )
                  },
                },
              ]}
            >
              <InputNumber
                disabled={isView}
                style={{ width: "100%" }}
                min={0}
                placeholder="Nhập số tiền"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={value => value.replace(/,/g, "")}
                onChange={value => {
                  form.setFieldValue("amount", value)
                  setAmount(value)
                }}
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault() // chặn mọi phím không phải số
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="type"
              label="Loại giao dịch"
              rules={[
                { required: true, message: "Vui lòng chọn loại giao dịch" },
              ]}
            >
              <Select
                disabled={isView}
                onChange={handleTypeChange}
                placeholder={"Chọn giao dịch"}
              >
                <Option value="deposit">Nạp tiền</Option>
                <Option value="withdrawal">Rút tiền</Option>
              </Select>
            </Form.Item>
          </Col>

          {isView && (
            <Col span={8}>
              <Form.Item name="status" label="Trạng thái">
                <Input disabled />
              </Form.Item>
            </Col>
          )}
        </Row>

        {/* {qrCode && (
          <Row>
            <Col span={24}>
              <div style={{ textAlign: "center" }}>
                <p>Mã QR Chuyển Tiền</p>
              </div>
            </Col>
            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Image src={qrCode} alt="QR Code" preview={false} />
              </div>
            </Col>
            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: 40,
                }}
              >
                <p
                  style={{ color: "#2C7BE5", fontSize: 20, fontWeight: "bold" }}
                >
                  Vietcombank
                </p>
                <p
                  style={{ color: "#28a745", fontSize: 22, fontWeight: "600" }}
                >
                  {Number(amount).toLocaleString()} VND
                </p>
                <p style={{ color: "#333", fontSize: 18, fontStyle: "italic" }}>
                  NGUYEN NGOC KIEN
                </p>
              </div>
            </Col>
          </Row>
        )} */}
      </Form>
    </Modal>
  )
}

export default CreateTransactionModal
